import type { ReactNode } from 'react'
import { cx } from './cx'
import { Icon, type IconName } from './Icon'
import styles from './Sidebar.module.css'

export interface SidebarItem {
  id: string
  label: string
  icon: IconName
  active: boolean
  badge?: number
}

interface SidebarProps {
  items: SidebarItem[]
  onSelect: (id: string) => void
  /** Account / condominium switcher, pinned to the bottom. */
  footer?: ReactNode
  /** Below 800px the sidebar is a top drawer. */
  open?: boolean
}

export function Sidebar({ items, onSelect, footer, open = false }: SidebarProps) {
  return (
    <aside className={cx(styles.sidebar, open && styles.open)}>
      <div className={styles.brand}>
        <div className={styles.tile}>
          <Icon name="apartment" size={19} />
        </div>
        <div>
          <div className={styles.name}>Condi</div>
          <div className={styles.tagline}>Painel do administrador</div>
        </div>
      </div>
      <nav aria-label="Seções" className={styles.nav}>
        {items.map((it) => (
          <button
            key={it.id}
            type="button"
            aria-current={it.active ? 'page' : undefined}
            className={cx(styles.item, it.active && styles.active)}
            onClick={() => onSelect(it.id)}
          >
            <Icon name={it.icon} size={19} className={styles.itemIcon} />
            <span className={styles.label}>{it.label}</span>
            {it.badge ? <span className={cx(styles.badge, 'tabular-nums')}>{it.badge}</span> : null}
          </button>
        ))}
      </nav>
      {footer && <div className={styles.footer}>{footer}</div>}
    </aside>
  )
}
